import { MuiOtpInput } from "mui-one-time-password-input";
import { Controller, useFormContext } from "react-hook-form";

import { validation } from "../../Utils/validations";

export default function OTPField() {
  const { control } = useFormContext();

  return (
    <Controller
      name="otp"
      control={control}
      rules={{
        required: "OTP is required",
        validate: (otp) => validation.otp.isValidOTP(otp) || "Invalid OTP",
      }}
      render={({ field }) => (
        <MuiOtpInput
          {...field}
          length={6}
          autoFocus
          aria-label="One-time passcode"
          TextFieldsProps={(index) => ({
            type: "number",
            inputProps: {
              inputMode: "numeric",
              pattern: "[0-9]*",
              "aria-label": `Digit ${index + 1} of 6`,
              autoComplete: "one-time-code",
            },
          })}
        />
      )}
    />
  );
}
